"use client";

import { useState } from "react";
import styles from "./OurStoryItemsMobile.module.css";

import { OUR_STORY } from "@/utils/utilsAbout";

function OurStoryItemsMobile() {
  const [currentVisibleItem, setCurrentVisibleItem] = useState(-1);

  return (
    <div className={styles.container}>
      {OUR_STORY.map(
        (item, index) =>
          item?.title && (
            <div className={styles.item} key={`${item.id}-${index}`}>
              <p className={styles.year}>{item.year}</p>
              <div className={styles.details}>
                <h3>{item.title}</h3>
                <div className={styles.icon}>{item.icon}</div>
                <p className={styles.description}>{item.description}</p>
              </div>
            </div>
          )
      )}
    </div>
  );
}

export default OurStoryItemsMobile;
